"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = require("coveo-search-ui");
var MainSearchInterfaceSelectorPrebind = (function () {
    function MainSearchInterfaceSelectorPrebind() {
        this.name = "mainSearchInterfaceSelector";
        this.resolvers = [
            new ResolveIfSelector(),
            new ResolveIfSearchInterfaceIdInPage(),
            new ResolveParentSearchInterfaceId(),
            new UseMainSearchInterfaceSelectorAsIs()
        ];
    }
    MainSearchInterfaceSelectorPrebind.prototype.getPrebind = function (args) {
        var _this = this;
        return function (mainSearchInterfaceId, element) {
            var resolver = _this.getFirstValidResolver(mainSearchInterfaceId, element);
            return resolver.getValue(mainSearchInterfaceId, element);
        };
    };
    MainSearchInterfaceSelectorPrebind.prototype.getFirstValidResolver = function (mainSearchInterfaceId, element) {
        var resolver;
        do {
            if (this.resolvers.length === 0) {
                var message = "Could not resolve the search interface element using the current resolver. Ensure that a valid value is set.";
                console.error(message, {
                    mainSearchInterfaceId: mainSearchInterfaceId,
                    element: element
                });
                throw message;
            }
            resolver = this.resolvers.shift();
        } while (!resolver.canResolve(mainSearchInterfaceId, element));
        return resolver;
    };
    return MainSearchInterfaceSelectorPrebind;
}());
exports.MainSearchInterfaceSelectorPrebind = MainSearchInterfaceSelectorPrebind;
var ResolveIfSearchInterfaceIdInPage = (function () {
    function ResolveIfSearchInterfaceIdInPage() {
    }
    ResolveIfSearchInterfaceIdInPage.prototype.canResolve = function (mainSearchInterfaceId) {
        return this.isMainSearchInterfaceDefined(mainSearchInterfaceId) &&
            this.isIdSelectorValid("#" + mainSearchInterfaceId);
    };
    ResolveIfSearchInterfaceIdInPage.prototype.getValue = function (mainSearchInterfaceId) {
        return "#" + mainSearchInterfaceId;
    };
    ResolveIfSearchInterfaceIdInPage.prototype.isMainSearchInterfaceDefined = function (mainSearchInterfaceId) {
        return !!mainSearchInterfaceId;
    };
    ResolveIfSearchInterfaceIdInPage.prototype.isIdSelectorValid = function (selector) {
        return document.querySelector(selector) !== null;
    };
    return ResolveIfSearchInterfaceIdInPage;
}());
var ResolveParentSearchInterfaceId = (function () {
    function ResolveParentSearchInterfaceId() {
    }
    ResolveParentSearchInterfaceId.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return this.getValue(mainSearchInterfaceId, element) !== null;
    };
    ResolveParentSearchInterfaceId.prototype.getValue = function (mainSearchInterfaceId, element) {
        if (typeof (this.foundId) === "undefined") {
            this.foundId = this.tryFindParentSearchInterfaceFromElement(element);
        }
        return this.foundId;
    };
    ResolveParentSearchInterfaceId.prototype.tryFindParentSearchInterfaceFromElement = function (element) {
        var parentSearchInterface = this.findParentWithClass(element, "Coveo" + coveo_search_ui_1.SearchInterface.ID);
        return !!parentSearchInterface ? "#" + parentSearchInterface.id : null;
    };
    ResolveParentSearchInterfaceId.prototype.findParentWithClass = function (element, className) {
        var parent = element.parentElement;
        while ((parent = parent.parentElement) && !parent.classList.contains(className)) { }
        return parent;
    };
    return ResolveParentSearchInterfaceId;
}());
var ResolveIfSelector = (function () {
    function ResolveIfSelector() {
    }
    ResolveIfSelector.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return !!mainSearchInterfaceId &&
            this.isStartingWithSelectorCharacter(mainSearchInterfaceId);
    };
    ResolveIfSelector.prototype.getValue = function (mainSearchInterfaceId, element) {
        return mainSearchInterfaceId;
    };
    ResolveIfSelector.prototype.isStartingWithSelectorCharacter = function (mainSearchInterfaceId) {
        var firstCharacter = mainSearchInterfaceId[0];
        return [".", "#"].indexOf(firstCharacter) !== -1;
    };
    return ResolveIfSelector;
}());
var UseMainSearchInterfaceSelectorAsIs = (function () {
    function UseMainSearchInterfaceSelectorAsIs() {
    }
    UseMainSearchInterfaceSelectorAsIs.prototype.canResolve = function (mainSearchInterfaceId, element) {
        return true;
    };
    UseMainSearchInterfaceSelectorAsIs.prototype.getValue = function (mainSearchInterfaceId, element) {
        return mainSearchInterfaceId;
    };
    return UseMainSearchInterfaceSelectorAsIs;
}());



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/prebindHelpers/MainSearchInterfaceSelector.ts
// module id = 42
// module chunks = 13 14